/**
 * HTTP side of the web records backend: the same /sync endpoints the desktop
 * engine uses, through the shared `api` client (bearer token, X-Client-Id,
 * refresh-on-401).
 *
 *   personal:<userId> -> /sync/personal/{bootstrap,pull,push}
 *   team:<teamId>     -> /sync/team/<teamId>/{bootstrap,pull,push}
 *   anything else     -> null (device-only scope, e.g. personal:local)
 */
import api from '../../services/apiService';
import { getClientId } from '../../utils/clientId';

export const PUSH_MAX_OPS = 500;

export function scopeBasePath(scopeKey) {
  const key = String(scopeKey || '');
  if (key.startsWith('personal:') && key !== 'personal:local') return '/sync/personal';
  if (key.startsWith('team:') && key.length > 'team:'.length) {
    return `/sync/team/${encodeURIComponent(key.slice('team:'.length))}`;
  }
  return null;
}

export const httpTransport = Object.freeze({
  bootstrap: (base) => api.get(`${base}/bootstrap`),
  pull: (base, since) => api.get(`${base}/pull`, { params: { since } }),
  push: (base, ops) => api.post(`${base}/push`, { client_id: getClientId(), ops }, { timeout: 30000 }),
});
